import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const quotationTask = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/quotation/{profile}/quotation-task',
    app: 'quotation',
    pk: 'id'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'quotation', model: 'quotation-task' }
    ),
    { }
  )
)()

export { quotationTask, TYPES }
